import {useCallback} from 'react';
import {useMutation} from '@apollo/client';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {addedNewYear} from '../store/slice';
import clonePartnerCostEntryYearMutation from '../graphql/clonePartnerCostEntryYearMutation';
import {PartnerCostEntryYear} from '../store/types';

interface UseClonePartnerCostEntryYearResult {
  clonePartnerCostEntryYear: (
    partnerId: string,
    onSuccess: (year: number) => void
  ) => Promise<void>;
}

export const useClonePartnerCostEntryYear =
  (): UseClonePartnerCostEntryYearResult => {
    const dispatch = useAppDispatch();

    const [cloneMutation] = useMutation<{
      cloneBusPartnerCostEntryYear: PartnerCostEntryYear;
    }>(clonePartnerCostEntryYearMutation, {
      errorPolicy: 'all'
    });

    const clonePartnerCostEntryYear = useCallback(
      async (partnerId: string, onSuccess: (year: number) => void) => {
        try {
          const {data, errors} = await cloneMutation({
            variables: {partnerId}
          });

          if (errors && errors.length > 0) {
            const errorMessage =
              errors[0]?.extensions?.errorMessage ?? errors[0].message;
            console.error('Clone partner cost entry year error:', errorMessage);
            return;
          }

          if (data?.cloneBusPartnerCostEntryYear) {
            const newEntryYear = {
              ...data.cloneBusPartnerCostEntryYear,
              busPartnerId: partnerId
            };
            dispatch(addedNewYear(newEntryYear));
            onSuccess(newEntryYear.year);
          }
        } catch (error) {
          const errorMessage = `Unexpected error while cloning partner cost entry year: ${error}`;
          console.error(errorMessage);
        }
      },
      [dispatch, cloneMutation]
    );

    return {clonePartnerCostEntryYear};
  };
